"use client";

import React, { Fragment, useCallback } from "react";

import { SupX } from "@repo/core-ui";
import LayoutSidebarModeRightBase from "@/components/Layout/Sidebar/Mode/RightBase";
import LayoutBackdrop from "@/components/Layout/Backdrop";
import UiTrapezeHandle from "@/components/Ui/TrapezeHandle";

import useGetOverlay from "@/store/hooks/useGetOverlay";
import { useStoredDataDispatch } from "@/store/Context";

export default function LayoutSidebarRight() {
  const storedDispatch = useStoredDataDispatch();

  const handleClose = useCallback(() => {
    storedDispatch({ type: "closeOverlay" });
  }, [storedDispatch]);

  const mode = useGetOverlay();

  return (
    mode !== undefined && (
      <Fragment>
        <aside className="fixed right-0 top-0 z-50 hidden h-full w-[420px] border-l-[.5px] border-neutral-600 bg-neutral-25 md:block">
          <nav className="absolute -left-[24px] flex flex-col">
            <UiTrapezeHandle className="rotate-180" onClick={handleClose} icon={<SupX className="z-10 size-3" />} />
          </nav>
          <section className="h-full max-h-screen w-full">
            <LayoutSidebarModeRightBase />
          </section>
        </aside>
        <LayoutBackdrop className="z-20" open onClick={handleClose} />
      </Fragment>
    )
  );
}
